import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Dialog, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const GDPRNotice: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    const consent = Cookies.get("gdpr-consent");
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    // Set a cookie to store user consent (expires in 365 days)
    Cookies.set("gdpr-consent", "accepted", { expires: 365 });
    setOpen(false);
  };

  const handlePreferences = () => {
    // Handle user preference logic here
    // For now, we just close the dialog
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleAccept}>
      <DialogContent>
        <Typography variant="h6">GDPR Consent</Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          We use cookies to improve your experience on our site and to show you relevant ads. By clicking "Accept", you agree to our use of cookies. For more information, read our <a href="/privacy-policy">Privacy Policy</a>.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePreferences}>Manage Preferences</Button>
        <Button onClick={handleAccept} id="acceptGdpr" variant="contained" color="primary">Accept</Button>
      </DialogActions>
    </Dialog>
  );
};

export default GDPRNotice;